export const emailValidationRules = {
  presence: { allowEmpty: false },
  email: true,
}

export const passwordValidationRules = { presence: { allowEmpty: false } }
